module.exports = __webpack_public_path__ + "static/media/img10.60220e39.jpg";